import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import _ from "lodash";
import "./style.css";
import "../style.css";
import "../../../common/style.css";
import {
  ColumnResizedEvent,
  FilterChangedEvent,
  FilterModifiedEvent,
  GridApi,
} from "ag-grid-community";
import "ag-grid-enterprise";
import Customtooltip from "../../../components/CustomTooltip/index";
import { onGridSizeChanged } from "../../../components/AgGrid/grid-util";
import { useLocation } from "react-router";
import { constants } from "../../../common/constants";
import { AllocationColumnDefs } from "../../../common/AllocationColumnDefs";
import { hasAccess } from "../../../common/commonFunctions";
import { pageConstant } from "../../../config/pageConstant";
import { getReturnsByContract } from "../../../utils/API";

interface AgGridProps {
  title?: string;
  rowData: any;
  height?: any;
  type?: string;
  onClickHan?: any;
  onClickSelectData?: any;
  onCellChange?: any;
  seTtotalSelectedRows?: any;
  getBtnRef?: any;
  getGridApi?: any;
  doesExternalFilterPass?: any;
  isExternalFilterPresent?: any;
  isDeselectAll?: boolean;
  getContextMenuItems?: any;
  globalSearch?: any;
  isSingleRowInserted?: boolean;
  defaultFilter?: any;
  appliedFilterStateAllocGrid?: any;
  filters?: any;
  allocatedCount: any;
  unallocatedCount: any;
  settledCount: any;
  unsettledCount: any;
  buyInCount: any;
  onRowSelected: any;
  applyAllocationMetricFilters: any;
  isResetFilters: boolean;
  onReturn?: any;
  setSelectedRows?: any;
  fullyReturnedCount?: any;
  insertRowId?: any[];
  currentSelectedContract?: any;
}

const AllocationsGrid = ({
  title,
  rowData,
  height,
  type,
  onClickHan,
  onClickSelectData,
  onCellChange,
  seTtotalSelectedRows,
  getBtnRef,
  getGridApi,
  doesExternalFilterPass,
  isExternalFilterPresent,
  isDeselectAll,
  getContextMenuItems,
  globalSearch,
  isSingleRowInserted,
  defaultFilter,
  appliedFilterStateAllocGrid,
  filters,
  allocatedCount,
  unallocatedCount,
  settledCount,
  unsettledCount,
  onRowSelected,
  applyAllocationMetricFilters,
  buyInCount,
  isResetFilters,
  onReturn,
  setSelectedRows,
  fullyReturnedCount,
  insertRowId,
  currentSelectedContract,
}: AgGridProps) => {
  const gridRef = useRef<any>(null);
  const [columnDefs] = useState<any>([...AllocationColumnDefs]);
  const [isAllocatedFilterActive, setIsAllocatedFilterActive] = useState(false);
  const [isUnallocatedFilterActive, setIsUnallocatedFilterActive] =
    useState(false);
  const [isSettledFilterActive, setIsSettledFilterActive] = useState(false);
  const [isUnsettledFilterActive, setIsUnsettledFilterActive] = useState(false);
  const [isBuyInFilterActive, setIsBuyInFilterActive] = useState(false);
  const [isFullyReturnedFilterActive, setIsFullyReturnedFilterActive] =
    useState(false);
  const [selectedGridRows, setSelectedGridRows] = useState<any>([]);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [flashedRowIds, setFlashedRowIds] = useState<any>([]);
  // const [currentRowTicker, setCurrentRowTicker] = useState(null)

  let gridApi: any;
  const defaultColDef = useMemo<any>(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      floatingFilter: false,
      suppressFilterButton: false,
      editable: true,
      resizable: true,
      headerCheckboxSelectionFilteredOnly: true,
      tooltipComponent: Customtooltip,
      menuTabs: [constants.FilterMenuTab],
      tooltipShowDelay: 10,
      tooltipMouseTrack: true,
      suppressKeyboardEvent: (params: any) => {
        let isTabKey = params?.event?.key === constants.Tab;
        if (isTabKey) gridRef?.current?.api?.stopEditing();
        return false;
      },
    };
  }, []);

  useEffect(() => {
    let refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef?.current!.api?.refreshCells(refreshParams);
  }, [globalSearch]);

  useEffect(() => {
    setTimeout(() => {
      filterMetricRows();
    }, 800);
  }, [
    isAllocatedFilterActive,
    isUnallocatedFilterActive,
    isSettledFilterActive,
    isUnsettledFilterActive,
    isBuyInFilterActive,
    isFullyReturnedFilterActive,
  ]);

  const filterMetricRows = () => {
    let filters = {
      isAllocatedFilterActive: isAllocatedFilterActive,
      isUnallocatedFilterActive: isUnallocatedFilterActive,
      isSettledFilterActive: isSettledFilterActive,
      isUnsettledFilterActive: isUnsettledFilterActive,
      isBuyInFilterActive: isBuyInFilterActive,
      isFullyReturnedFilterActive: isFullyReturnedFilterActive,
    };
    applyAllocationMetricFilters?.(filters);
  };

  useEffect(() => {
    gridApi = gridRef.current!.api;
    var gridColumnApi = gridRef.current!.columnApi;
    getUpdatedData(rowData);
    getBtnRef(gridRef);
    getName(gridApi, gridColumnApi);
  }, [rowData]);

  const onColumnResized = useCallback((params: ColumnResizedEvent) => {}, []);

  const getUpdatedData = useCallback(
    async (data: any) => {
      await gridApi?.applyTransactionAsync({ update: [rowData] });
      if (gridRef && gridRef?.current && gridRef?.current!.api) {
        if (insertRowId && insertRowId?.length > 0) {
          const rowNodes: any[] = [];
          insertRowId?.forEach((id: any, index: number) => {
            const rowNode = gridRef?.current?.api?.getRowNode(id);
            if (rowNode && !_.includes(flashedRowIds, id)) {
              rowNodes.push(rowNode);
            } else {
              const rowNode =
                gridRef?.current?.api?.getDisplayedRowAtIndex(index);
              if (rowNode) rowNodes.push(rowNode);
            }
          });
          setFlashedRowIds((previousIds: any) => [insertRowId, ...previousIds]);
          gridApi?.flashCells({ rowNodes: rowNodes });
        }
        gridRef.current!.api.refreshCells();
      }
      gridRef.current!.api.refreshCells();
    },
    [rowData]
  );

  useEffect(() => {
    if (defaultFilter && gridRef) {
      const filterComponent = gridRef?.current?.api?.getFilterInstance(
        defaultFilter.column
      );
      if (filterComponent) {
        filterComponent?.setModel({ values: defaultFilter.values });
        gridApi.onFilterChanged();
      }
    }
  }, [gridRef]);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
    gridApi = params.api;

    var gridColumnApi = params.columnApi;
    // Emmits the gridApi refrence to the parent component
    if (getGridApi) {
      getGridApi(gridApi, gridColumnApi);
    }
  };

  /**
   * Executes whenever Grid/Table filter modifies - this is more sensitive
   * @param params
   */
  const onFilterModified = (params: FilterModifiedEvent) => {
    const { api, columnApi } = params;
  };

  /**
   * Executes whenever Grid/Table filter changes
   * @param params
   */
  const onFilterChanged = (params: FilterChangedEvent) => {
    const { api, columnApi } = params;
    appliedFilterStateAllocGrid(api?.getFilterModel());
    getName(api, columnApi);
  };

  const onFirstDataRendered = () => {
    let gridColumnApi = gridRef?.current!.columnApi;
    let gridRefApi = gridRef?.current!.api;
    getName(gridRefApi, gridColumnApi);
  };

  const { pathname } = useLocation();
  /**
   * To skip pinned rows on the basis of Page path
   * @returns shouldSkip : boolean
   */
  const skipPinnedRow = (): boolean => {
    if (pathname && typeof pathname === "string") {
      const pathsToSkip = ["secmaster", "counterParty"];
      for (let aPath of pathsToSkip) {
        if (pathname.endsWith(aPath)) return true;
      }
    }

    //Skip for Contract Activity Popup
    if (type === constants.ContractActivity) return true;

    return false;
  };

  const getName = (api: any, columnApi: any) => {
    if (!api || !columnApi || skipPinnedRow()) return;
    let rows: any = {};
    var result = [];
    columnApi?.getAllGridColumns().forEach((item: any) => {
      rows[item.colId] = null;
    });
    let columnsWithAggregation = [
      "borrow_quantity",
      "borrow_amt",
      "return_quantity",
      "return_amt",
    ];
    columnsWithAggregation.forEach((element) => {
      api?.forEachNodeAfterFilter((rowNode: any) => {
        if (rowNode && rowNode.data && rowNode.data[element]) {
          rows[element] += Number(parseFloat(rowNode.data[element]));
        }
      });
    });
    let contractIdTotal = ["contract_id"];
    let countContractId_ = 0;
    contractIdTotal.forEach((element) => {
      api?.forEachNodeAfterFilter((rowNode: any) => {
        countContractId_++;
        if (rowNode && rowNode.data && rowNode.data[element]) {
          rows[element] += Number(parseFloat(rowNode.data[element]));
        }
      });
    });
    rows["contract_id"] = countContractId_;
    var count = Number(2);
    for (var i = 0; i < count; i++) {
      if (i === 0) {
        result.push({
          isTotalRow: true,
          contract_id: "Rows",
          cpty_id: "CPTY",
          ticker: "Symbol",
          borrow_quantity: "Borrow Qty",
          borrow_amt: "Borrow Value",
          return_quantity: "Return Qty",
          remain_qty: "Remain Qty",
          return_amt: "Return Value",
        });
      } else {
        rows["isTotalRow"] = true;
        rows["ticker"] = countUnique("ticker", api);
        rows["cpty_id"] = countUnique("cpty_id", api);
        rows["remain_qty"] = rows["borrow_quantity"] - rows["return_quantity"];
        result.push(rows);
      }
    }
    api?.setPinnedBottomRowData(result);
  };

  /**
   * Method counts the unique value for given attribute (for filtered values also)
   * @param attribute
   * @returns unique values count
   */
  const countUnique = (attribute: string, api: GridApi): number => {
    const uniqueItemsSet: Set<any> = new Set();
    api?.forEachNodeAfterFilter((rowNode: any) => {
      if (
        rowNode?.data instanceof Object &&
        attribute in rowNode.data &&
        !_.isEmpty(rowNode.data[attribute])
      ) {
        uniqueItemsSet.add(rowNode.data[attribute]);
      }
    });
    return uniqueItemsSet.size;
  };

  useEffect(() => {
    let gridRefApi = gridRef?.current!.api;
    gridRefApi?.setFilterModel?.(null);
    setIsAllocatedFilterActive(false);
    setIsUnallocatedFilterActive(false);
    setIsSettledFilterActive(false);
    setIsUnsettledFilterActive(false);
    setIsBuyInFilterActive(false);
    setIsFullyReturnedFilterActive(false);
    gridRefApi?.deselectAll?.();
    gridRef.current?.api?.deselectAll();
    setSelectedGridRows([]);
  }, [isResetFilters]);

  useEffect(() => {
    if (isDeselectAll != undefined) {
      gridRef.current?.api?.deselectAll();
      setSelectedGridRows([]);
    }
  }, [isDeselectAll]);

  const onSelectionChanged = (params: any) => {
    const selectedRows = gridRef.current!.api.getSelectedRows();
    if (
      params?.source === "uiSelectAllFiltered" &&
      params?.type === "selectionChanged"
    ) {
      if (selectedRows?.length > 0) {
        const groupedContracts = _.groupBy([...selectedRows], "contract_id");
        let list: any = [];
        _.forOwn(groupedContracts, function (value, key) {
          const allocatedList = value?.filter(
            (x: any) => x?.isAllocated === "Y"
          );
          const updatedQty: any = _.sumBy(allocatedList, "return_quantity");
          let contract: any = value[0];
          if (contract?.borrow_quantity > 0) {
            contract.returned_quantity = updatedQty;
            if (
              contract?.borrow_amt &&
              contract?.borrow_quantity &&
              contract?.borrow_quantity > 0
            ) {
              let cp = (
                contract?.borrow_amt / contract?.borrow_quantity
              )?.toString();
              cp =
                cp && contract?.borrow_amt / contract?.borrow_quantity > 0
                  ? parseFloat(cp).toFixed(4)
                  : cp;
              contract.contractPrice = cp;
            }
            list.push(contract);
          }
        });
        setSelectedGridRows(list);
      } else {
        setSelectedGridRows([]);
      }
    } else if (selectedRows?.length === 0) {
      setSelectedGridRows([]);
    }
  };

  const onGridRowSelected = (params: any) => {
    if (params?.source !== "uiSelectAllFiltered") {
      let contracts: any[] = [];
      let selected: any[] = [];
      if (params?.node?.selected) {
        contracts = rowData?.filter(
          (x: any) => x.contract_id === params?.data?.contract_id
        );
      //  getAllocationsByContract(params?.data?.contract_id, "B").then(
      //     (res: any) => {
      //       contracts = res
      //       const allocatedList = contracts?.filter(
      //         (x: any) => x.isAllocated === "Y"
      //       );
      //       const updatedQty = _.sumBy(allocatedList, "return_quantity");
      //       if (!params?.data?.isFullyReturned) {
      //         const updatedRows = contracts.map((r: any) => {
      //           return {
      //             ...r,
      //             returned_quantity: updatedQty,
      //             contractPrice:
      //               r?.borrow_amt &&
      //               r?.borrow_quantity &&
      //               r.borrow_quantity > 0 &&
      //               r?.borrow_amt / r?.borrow_quantity > 0
      //                 ? parseFloat(
      //                     (r?.borrow_amt / r?.borrow_quantity).toString()
      //                   ).toFixed(2)
      //                 : "",
      //           };
      //         });

      //         selected = _.uniqBy([...updatedRows], "contract_id");
      //         setSelectedGridRows((previousRows: any) => {
      //           if (_.isArray(previousRows)) {
      //             return _.concat(previousRows, selected);
      //           }
      //           return previousRows;
      //         });
      //         contracts?.forEach((r: any) => {
      //           const rowNode = params?.api
      //             ?.getRowNode(
      //               r?.returns_id > 0 ? r?.returns_id : r?.contract_id
      //             )
      //           if(rowNode){
      //             if(rowNode && rowNode?.data && (rowNode?.data?.returns_id >0? rowNode?.data?.returns_id === r?.returns_id:rowNode?.data?.contract_id === r?.contract_id )){
      //               rowNode.data = r;
      //             }
                  
      //             rowNode?.setSelected(true)
      //           }
                  
      //           // params?.api
      //           //   ?.getRowNode(
      //           //     r?.returns_id > 0 ? r?.returns_id : r?.contract_id
      //           //   )
      //           //   .setSelected(true);
      //         });
      //       }
      //     }
      //   );
        // currentSelectedContract?.(params?.data?.contract_id)
        const allocatedList = contracts?.filter((x:any)=> x.isAllocated === 'Y')
         const updatedQty = _.sumBy(allocatedList, "return_quantity");
          if (!params?.data?.isFullyReturned) {
          const updatedRows = contracts.map((r: any) => {
            return { ...r, returned_quantity: updatedQty,
              contractPrice:r?.borrow_amt && r?.borrow_quantity &&  r.borrow_quantity > 0 &&
                r?.borrow_amt / r?.borrow_quantity > 0 ? parseFloat(
                  (r?.borrow_amt / r?.borrow_quantity).toString()
                ).toFixed(2)
                : "" };
          });

          selected = _.uniqBy([...updatedRows], "contract_id");
          setSelectedGridRows((previousRows: any) => {
            if (_.isArray(previousRows)) {
              return _.concat(previousRows, selected);
            }
            return previousRows;
          });
          contracts?.forEach((r: any) => {
            // const contractRow = rowData?.find((cr: any)=> (cr?.returns_id >0 ? r?.returns_id=== cr?.returns_id : r?.contract_id === cr?.contract_id))
            // if(contractRow){
              params?.api?.getRowNode(r?.returns_id>0?r?.returns_id:r?.contract_id).setSelected(true);
            // params?.api?.getDisplayedRowAtIndex(+contractRow?.id).setSelected(true);
          // }

          });
        }
      } else {
        contracts = rowData?.filter(
          (x: any) => x.contract_id === params?.data?.contract_id
        );
        const updatedRows = _.pullAllBy(selectedGridRows, contracts, "id");
        selected = [...updatedRows];
        setSelectedGridRows(selected);
        contracts?.forEach((r: any) => {
          // const contractRow = rowData?.find((cr: any)=> (cr?.returns_id >0 ? r?.returns_id=== cr?.returns_id : r?.contract_id === cr?.contract_id))
          // if(contractRow){
          params?.api
            ?.getRowNode(r?.returns_id > 0 ? r?.returns_id : r?.contract_id)
            .setSelected(false);
          //params?.api?.getDisplayedRowAtIndex(+contractRow?.id).setSelected(false);
          // }
        });
        // contracts?.map((r: any) => {
        //   const rowNode = params?.api?.getRowNode(r?.returns_id?r?.returns_id:r?.contract_id);
        //   params?.api?.getRowNode(r?.returns_id?r?.returns_id:r?.contract_id).setSelected(false);
        //   return rowNode;
        // });
      }
    }
  };

  useEffect(() => {
    const uniqueRecords = _.uniqBy(selectedGridRows, "contract_id");
    setSelectedRows(uniqueRecords);
  }, [selectedGridRows]);

  const onCellValueChanged = useCallback((event: any) => {
    let updateArray: any = [];
    event.value = event.value.toUpperCase();
    onCellChange(event.data, event.value, event.column);
    updateArray.push(event.data);

    gridApi = gridRef.current!.api;
    var gridColumnApi = gridRef.current!.columnApi;
    gridApi?.applyTransaction({ update: updateArray });
    var params = {
      force: true,
      suppressFlash: true,
      columns: [event.column],
    };
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 100,
      maxWidth: 200,
    };
  }, []);

  const getRowId = useMemo(() => {
    return (params: any) => params.data.id;
    // return (params: any) =>
    //   (params.data.contract_id ? params.data.contract_id.toString() : "") +
    //   (params.data.bl ? params.data.bl.toString() : "") +
    //   (params.data.returns_id ? params.data.returns_id.toString() : "");
  }, []);

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressColumnFilter: false,
            suppressColumnSelectAll: false,
            suppressColumnExpandAll: true,
          },
        },
      ],
      defaultToolPanel: "",
    };
  }, []);

  const onGridRowDataChanged = (params: any) => {
    let refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef.current!.api.refreshCells(refreshParams);
    setTimeout(() => {
      if (gridRef && gridRef?.current && gridRef?.current!.api) {
        if (filters) {
          if (gridApi?.getFilterModel() !== filters)
            gridApi?.setFilterModel(filters);
        }
      }
    }, 500);
  };

  const onAllocateFilter = (isAllocatedSelected: boolean = false) => {
    if (isAllocatedSelected) {
      if (!isAllocatedFilterActive && isUnallocatedFilterActive) {
        setIsUnallocatedFilterActive(false);
      }
      setIsAllocatedFilterActive(!isAllocatedFilterActive);
    } else {
      if (!isUnallocatedFilterActive && isAllocatedFilterActive) {
        setIsAllocatedFilterActive(false);
      }
      setIsUnallocatedFilterActive(!isUnallocatedFilterActive);
    }
  };

  const onSettledFilter = (isSettledSelected: boolean = false) => {
    if (isSettledSelected) {
      if (!isSettledFilterActive && isUnsettledFilterActive) {
        setIsUnsettledFilterActive(false);
      }
      setIsSettledFilterActive(!isSettledFilterActive);
    } else {
      if (!isUnsettledFilterActive && isSettledFilterActive) {
        setIsSettledFilterActive(false);
      }
      setIsUnsettledFilterActive(!isUnsettledFilterActive);
    }
  };

  const onCellFocused = (event: any) => {
    if (
      event &&
      !_.isUndefined(event?.rowIndex) &&
      !_.isNull(event?.rowIndex)
    ) {
      let rowNode = gridRef?.current?.api?.getDisplayedRowAtIndex(
        event?.rowIndex
      );
      if (rowNode && event?.rowPinned !== "bottom") {
        const selected: any = [];
        selected.push(rowNode);
        gridRef?.current?.api?.setNodesSelected({
          nodes: selected,
          newValue: true,
        });
      }
    }
  };

  useEffect(() => {
    let refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef?.current!.api?.refreshCells(refreshParams);
  }, [globalSearch]);

  const onDoesfilter = useCallback((node: any) => {
    doesExternalFilterPass(node);
    return true;
  }, []);

  const onRowClicked = (params: any) => {
    if (params?.data?.ticker || params?.data?.sec_id) {
      const id =
        params?.data?.returns_id > 0
          ? params?.data?.returns_id
          : params?.data?.contract_id;
      setCurrentRowId(id);
      // setCurrentRowTicker(params?.data?.ticker)
      onRowSelected(params?.data?.ticker, params?.data?.sec_id);
      const refreshParams: any = {
        force: true,
        suppressFlash: true,
      };
      setTimeout(() => {
        gridRef?.current!.api?.redrawRows(refreshParams);
      }, 50);
    }
  };

  const isRowSelectable = useMemo(() => {
    return (rowNode: any) => {
      return (
        rowNode?.data?.borrow_quantity !== 0 &&
        !rowNode?.data?.isFullyReturned &&
        rowNode?.data?.processing_status !== "Pending"
      );
    };
  }, []);

  const getRowStyle: any = (params: any) => {
    if (
      ((params.node.data?.returns_id > 0 &&
        params.node.data?.returns_id === currentRowId) ||
        (params.node.data?.contract_id &&
          params.node.data?.contract_id === currentRowId)) &&
      params.node.rowPinned !== "bottom"
    ) {
      params.node.suppressRowHoverHighlight = true;
      return { background: "#bbdffc" };
    } else if (
      params.node.rowIndex % 2 === 0 &&
      params.node.rowPinned !== "bottom"
    ) {
      return { background: "#F8F8F8" };
    }
    if (params.node.rowPinned === "bottom") {
      return {
        backgroundColor: "#fff !importnat",
        color: "#164691",
        fontWeight: "700",
        fontSize: "0.75rem",
        fontStyle: "normal",
        borderBottom: "none",
        border: "none",
      };
    } else {
      return { backgroundColor: "#fff" };
    }
  };

  const getRowClass = (params: any) => {
    if (
      params.node.data?.id === currentRowId &&
      params.node.rowPinned !== "bottom"
    ) {
      return "row-selected-cs";
    }
    return undefined;
  };

  const getAllocationsByContract = async (contractId: any, bl: any) => {
    const request = {
      contract_id: contractId,
      bl: bl,
    };

    try {
      return await getReturnsByContract(request).then(
        async (allocationsRes: any) => {
          if (allocationsRes?.status === 200) {
            const contractList = await allocationsRes.json();

            return contractList;
          } else if (allocationsRes?.status === 401) {
            return [];
          } else {
            return [];
          }
        }
      );
    } catch (err) {
      return [];
    }
  };

  return (
    <>
      <div
        className="d-flex flex-row justify-content-between "
        style={{ backgroundColor: "var(--secondary_white)" }}
      >
        <div className="justify-content-start">
          {title !== undefined && (
            <div
              // style={{ height: "1rem", paddingLeft:'0.3rem', paddingTop:'0.8rem', paddingBottom:'0.8rem' }}
              className="drag-handle"
            >
              {title}
            </div>
          )}
        </div>
        <div
          className="d-flex flex-row justify-content-between me-2"
          style={{ height: "1.2rem", paddingTop: "0.8rem" }}
        >
          <div className="d-flex flex-row justify-content-between">
            <div className="form-check form-switch d-flex align-self-center">
              <input
                checked={isFullyReturnedFilterActive}
                onChange={() =>
                  setIsFullyReturnedFilterActive(!isFullyReturnedFilterActive)
                }
                className="form-check-input me-2"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
              />
              <label
                className="form-check-label text-nowrap mb-0 align-self-center"
                style={{ fontSize: "small" }}
                htmlFor="flexSwitchCheckDefault"
              >
                Exclude Full Return
              </label>
            </div>
          </div>
        </div>
      </div>
      <div
        className="w-100 row p-0 d-flex align-items-center"
        style={{ height: "3%", marginBottom: 2 }}
      >
        <div className="float-start ps-2 col-10 d-flex align-items-center h-100">
          <div className="ms-2 h-100 d-flex align-items-center metrics-div">
            <button
              type="button"
              onClick={() => {
                onAllocateFilter(true);
              }}
              className={`metrics-btn p-1 h-75 d-flex align-items-center btn btn-allocated ${
                isAllocatedFilterActive ? "btn btn-filter-active" : ""
              }`}
            >
              Allocated ({allocatedCount})
            </button>
          </div>
          <div className="ms-2 h-100 d-flex align-items-center metrics-div">
            <button
              type="button"
              onClick={() => {
                onAllocateFilter();
              }}
              className={`metrics-btn p-1 h-75 d-flex btn btn-unallocated align-items-center ${
                isUnallocatedFilterActive ? "btn btn-filter-active" : ""
              }`}
            >
              Unallocated ({unallocatedCount})
            </button>
          </div>
          <div className="ms-2 d-flex align-items-center  metrics-div h-100">
            <button
              type="button"
              onClick={() => {
                onSettledFilter(true);
              }}
              className={`metrics-btn p-1 d-flex align-items-center h-75 btn btn-settled ${
                isSettledFilterActive ? "btn btn-filter-active" : ""
              }`}
            >
              Settled ({settledCount})
            </button>
          </div>
          <div className="ms-2 d-flex align-items-center h-100 metrics-div">
            <button
              type="button"
              onClick={() => {
                onSettledFilter();
              }}
              className={`metrics-btn p-1 d-flex align-items-center h-75 btn btn-unsettled ${
                isUnsettledFilterActive ? "btn btn-filter-active" : ""
              }`}
            >
              Unsettled ({unsettledCount})
            </button>
          </div>
          <div className="ms-2 d-flex align-items-center h-100 metrics-div">
            <button
              type="button"
              onClick={() => {
                setIsBuyInFilterActive(!isBuyInFilterActive);
              }}
              className={`metrics-btn p-1 d-flex align-items-center h-75 btn btn-buy-in ${
                isBuyInFilterActive ? "btn btn-filter-active" : ""
              }`}
            >
              Buy In ({buyInCount})
            </button>
          </div>
        </div>
        <div className="col-2 p-0 h-100 d-flex justify-content-end">
          <button
            type="button"
            onClick={onReturn}
            disabled={
              selectedGridRows?.length === 0 ||
              !hasAccess([
                `${pageConstant?.CONTRACT_ACTIVITY}_ADMIN`,
                `${pageConstant?.CONTRACT_ACTIVITY}_RW`,
              ])
            }
            style={{ width: "4rem !important" }}
            className="ms-2 btn btn-primary d-flex align-self-center allocate-btn"
          >
            Allocate
          </button>
        </div>
      </div>
      <div className="ag-theme-balham" style={{ height: "89.5%" }}>
        <AgGridReact
          ref={gridRef}
          rowStyle={{
            justifyContent: "center",
            color: "#2D2D2D",
            fontSize: "0.75rem",
            fontWeight: "400",
            fontStyle: "normal",
          }}
          rowHeight={22}
          columnDefs={columnDefs}
          getRowId={getRowId}
          onFirstDataRendered={onFirstDataRendered}
          onRowDataUpdated={onGridRowDataChanged}
          rowData={rowData}
          rowSelection={"multiple"}
          onSelectionChanged={onSelectionChanged}
          defaultColDef={defaultColDef}
          suppressAggFuncInHeader={true}
          enableCellChangeFlash={true}
          enableRangeSelection={true}
          onGridReady={onGridReady}
          onFilterModified={onFilterModified}
          onFilterChanged={onFilterChanged}
          onGridSizeChanged={onGridSizeChanged}
          onColumnResized={onColumnResized}
          getRowClass={getRowClass}
          getRowStyle={getRowStyle}
          onCellValueChanged={onCellValueChanged}
          autoGroupColumnDef={autoGroupColumnDef}
          groupSelectsChildren={true}
          groupSelectsFiltered={true}
          sideBar={sideBar}
          pivotMode={false}
          cacheQuickFilter={false}
          isExternalFilterPresent={isExternalFilterPresent}
          doesExternalFilterPass={onDoesfilter}
          getContextMenuItems={getContextMenuItems}
          quickFilterText={globalSearch}
          overlayLoadingTemplate={
            '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          }
          onRowClicked={onRowClicked}
          onRowSelected={onGridRowSelected}
          isRowSelectable={isRowSelectable}
          suppressRowClickSelection={true}
          suppressRowHoverHighlight={true}
        ></AgGridReact>
      </div>
    </>
  );
};

function CustomTooltip() {}

CustomTooltip.prototype.init = function (params: any) {
  var type = params.type || "primary";
  var data = params.api.getDisplayedRowAtIndex(params.rowIndex).data;
  var eGui = (this.eGui = document.createElement("div"));

  eGui.classList.add("custom-tooltip");
  this.eGui.innerHTML =
    '<div class="panel panel-' +
    type +
    '">' +
    '<div class="panel-heading">' +
    '<h3 class="panel-title">' +
    data.country +
    "</h3>" +
    "</div>" +
    '<div class="panel-body">' +
    '<h4 style="white-space: nowrap;">' +
    data.athlete +
    "</h4>" +
    "<p>Total: " +
    data.total +
    "</p>" +
    "</div>" +
    "</div>";
};

CustomTooltip.prototype.getGui = function () {
  return this.eGui;
};

export default AllocationsGrid;
